<div class="header-page">
  <div class="header-commission-text">
    <mat-icon routerLink="/commissions">chevron_left</mat-icon>Commission
    Details -
    {{ deal?.line1Address }}
  </div>
  <div>
    @if (
      !!transactionList?.total && !!promisedPayment?.id && (deal | isStatement)
    ) {
      <button mat-button (click)="downloadStatement(promisedPayment!.id)">
        {{
          'deal-details.component.download_statement_link'
            | localise: 'Download statement'
        }}
      </button>
    }
  </div>
</div>
<div class="deal-detail-page">
  @if (loading) {
    <mat-spinner [diameter]="50"></mat-spinner>
  }
  @if (!loading && !deal && error) {
    <p class="p-error-message p-error-message--margin">{{ error }}</p>
  }
  @if (deal) {
    <!-- Advance section -->
    <div class="content-commission">
      <div class="header-cloc">
        <h3>
          {{
            'dashboard-commission-details.component.commission_header'
              | localise: 'Commission'
          }}
        </h3>

        <div class="action-cloc-block">
          @if (
            (deal?.status === dealStatusEnum.Approved &&
              !(user | async)?.inExternalCollectionAt) ||
            true
          ) {
            <a
              href="javascript:void(0)"
              (click)="openMakeChanges(updateClosingDateTmp)"
              class="tongo-link">
              {{
                'deal-details.component.change_closing_date_link'
                  | localise: 'Change Closing Date'
              }}
            </a>
          }
          @if (deal?.userDealDocuments?.[0]; as document) {
            @if (loadingFile) {
              <mat-spinner [diameter]="22"></mat-spinner>
            }
            @if (!loadingFile) {
              <app-preview-document
                [documentName]="document.s3Key | fileName"
                [fileName]="document.s3Key"
                [documentId]="document.id">
                <a href="javascript:void(0)" class="tongo-link header-button">
                  {{
                    'deal-details.component.view_contract_link'
                      | localise: 'View Contract'
                  }}
                </a>
              </app-preview-document>
            }
          } @else {
            <p>
              @if (loadingFile) {
                <mat-spinner [diameter]="22"></mat-spinner>
              }
              <label class="upload-button" [class.hidden]="loadingFile">
                {{
                  'deal-details.component.upload_contract'
                    | localise: 'Upload Contract'
                }}
                <input
                  type="file"
                  accept=".pdf,.doc,.docx,.dot,.dotx,.docm,.dotm"
                  ngFileSelect
                  [options]="options"
                  (uploadOutput)="onUploadOutput($event)"
                  [uploadInput]="uploadInput" />
              </label>
            </p>
          }
        </div>
      </div>
      <ul>
        <li>
          <h4>
            {{
              'dashboard-commission-details.component.property_address'
                | localise: 'Property Address'
            }}
          </h4>
          <p>{{ deal | fullAddress }}</p>
        </li>
        <li>
          <h4>
            {{
              'dashboard-commission-details.component.commission_amount'
                | localise: 'Your Net Commission'
            }}
          </h4>
          <p>
            {{ deal?.agentCommissionAmount | currencyJs: { showSymbol: true } }}
          </p>
        </li>
        <li>
          <h4>
            {{
              'deal-details.component.expected_closing_date'
                | localise: 'Expected Closing Date'
            }}
          </h4>
          <p>{{ deal?.closingDate | dateApp: formatDateEnum.MMMDD }}</p>
        </li>
        <li>
          <h4>
            {{
              'deal-details.component.selling_agent' | localise: 'Selling Agent'
            }}
          </h4>
          <p>{{ this.authenticationService.getProfileState().fullName }}</p>
        </li>
      </ul>
    </div>
    <!-- Advance section -->
    @if (deal?.approvedLimitAmount) {
      <div class="content-commission">
        <div class="header-cloc">
          <h3>
            {{
              'dashboard-commission-details.component.cloc'
                | localise: 'Advance'
            }}
          </h3>
          @if (transactionList?.list?.length) {
            <div
              (click)="showTransactions = !showTransactions"
              class="header-button">
              <a>Show transactions</a>
              @if (showTransactions) {
                <mat-icon>expand_less</mat-icon>
              } @else {
                <mat-icon>expand_more</mat-icon>
              }
            </div>
          }
        </div>

        <ul [class.m-b-24]="showTransactions">
          <li>
            <h4>
              {{
                'deal-details.component.date_requested'
                  | localise: 'Date Requested'
              }}
            </h4>
            <p>
              {{ deal?.createdAt | dateApp: formatDateEnum.MMMDDYYYY }}
            </p>
          </li>
          <li>
            <h4>
              {{
                'dashboard-commission-details.component.approved_limit'
                  | localise: 'Approved Limit'
              }}
            </h4>
            <p>
              {{ deal?.approvedLimitAmount | currencyJs: { showSymbol: true } }}
            </p>
          </li>
          <li>
            <h4>
              {{
                'dashboard-commission-details.component.amount_used'
                  | localise: 'Amount Used'
              }}
            </h4>
            <p>
              {{ balance?.unpaidPrincipal | currencyJs: { showSymbol: true } }}
            </p>
          </li>
          <li>
            <h4>
              {{
                'dashboard-commission-details.component.amount_remaining'
                  | localise: 'Amount Remaining'
              }}
            </h4>
            @if (deal && balance?.unpaidPrincipal) {
              <p>
                {{
                  deal.approvedLimitAmount.subtract(balance.unpaidPrincipal)
                    | currencyJs: { showSymbol: true }
                }}
              </p>
            } @else {
              <p>
                {{
                  deal?.approvedLimitAmount | currencyJs: { showSymbol: true }
                }}
              </p>
            }
          </li>
          <li>
            <h4>
              {{
                'dashboard-commission-details.component.total_fees'
                  | localise: 'Total Fees'
              }}
            </h4>
            <p>
              {{ balance?.unpaidFees | currencyJs: { showSymbol: true } }}
            </p>
          </li>
          <li>
            <h4>
              {{
                'dashboard-commission-details.component.balance_owed'
                  | localise: 'Balance Owed'
              }}
            </h4>
            @if (balance) {
              <p>
                {{
                  balance.unpaidFees.add(balance.unpaidPrincipal)
                    | currencyJs: { showSymbol: true }
                }}
              </p>
            } @else {
              <p>$0.00</p>
            }
          </li>
          <!-- TODO Next Payment Due-->
          <li>
            <h4>
              {{
                'dashboard-commission-details.component.next_payment_due'
                  | localise: 'Next Payment Due'
              }}
            </h4>
            <!--        <p>-->
            <!--          {{ externalDeal?.createdAt | dateApp : formatDateEnum.MMMDDYYYY }}-->
            <!--        </p>-->
          </li>
        </ul>
        @if (showTransactions) {
          <div class="table-wrapper hide-commission">
            <div class="header-deposit">Transactions</div>
            <ng-container
              *ngTemplateOutlet="
                activityFullTable;
                context: {
                  withSubTable: true,
                  dataSource: transactionList?.list,
                  columns: columns,
                  subColumns: subColumns,
                }
              "></ng-container>

            <ng-template
              #activityFullTable
              let-withSubTable="withSubTable"
              let-columns="columns"
              let-subColumns="subColumns"
              let-dataSource="dataSource">
              <table
                mat-table
                multiTemplateDataRows
                [class.without-last-border]="!withSubTable"
                class="commission-table"
                [dataSource]="dataSource">
                <ng-container matColumnDef="date">
                  <th mat-header-cell *matHeaderCellDef class="commission-th">
                    Date
                  </th>
                  <td mat-cell *matCellDef="let app" class="commission-td">
                    @if (!app.payment) {
                      @if (app.calculatedEffectiveDate) {
                        {{
                          app.calculatedEffectiveDate
                            | dateApp: formatDateEnum.MMMDD
                        }}
                      } @else if (app.date) {
                        {{ app.date | dateApp: formatDateEnum.MMMDD }}
                      } @else {
                        {{ app.createdAt | dateApp: formatDateEnum.MMMDD }}
                      }
                    } @else {
                      {{ app.groupId }}
                    }
                  </td>
                </ng-container>
                <ng-container matColumnDef="payoutState">
                  <th mat-header-cell *matHeaderCellDef class="commission-th">
                    Payout State
                  </th>
                  <td mat-cell *matCellDef="let app" class="commission-td">
                    @if (app?.payoutState !== undefined) {
                      {{ transactionPayoutStateNames[app.payoutState] }}
                    } @else {
                      -
                    }
                  </td>
                </ng-container>
                <ng-container matColumnDef="amount">
                  <th mat-header-cell *matHeaderCellDef class="commission-th">
                    {{
                      'dashboard-activity.component.amount_header'
                        | localise: 'Amount'
                    }}
                  </th>
                  <td mat-cell *matCellDef="let app" class="commission-td">
                    {{ app.amount | currencyJs: { showSymbol: true } }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="unpaidAmount">
                  <th mat-header-cell *matHeaderCellDef class="commission-th">
                    {{
                      'dashboard-activity.component.unpaid_amount_header'
                        | localise: 'Unpaid Amount'
                    }}
                  </th>
                  <td mat-cell *matCellDef="let app" class="commission-td">
                    @if (!app.payment) {
                      {{ app.unpaidAmount | currencyJs: { showSymbol: true } }}
                    } @else {
                      -
                    }
                  </td>
                </ng-container>
                <ng-container matColumnDef="type">
                  <th mat-header-cell *matHeaderCellDef class="commission-th">
                    {{
                      'dashboard-activity.component.type_header'
                        | localise: 'Type'
                    }}
                  </th>
                  <td mat-cell *matCellDef="let app" class="commission-td">
                    @if (!app.payment) {
                      @if (app.activityType === 't') {
                        @if (app.description === 'Instant Transfer') {
                          {{ app.description }}
                        } @else {
                          {{ transactionTypeNames[app.type] }}
                        }
                      } @else {
                        {{
                          'dashboard-activity.component.payout'
                            | localise: 'Payout'
                        }}
                      }
                    } @else {
                      -
                    }
                  </td>
                </ng-container>
                <ng-container matColumnDef="creditCardNumber">
                  <th mat-header-cell *matHeaderCellDef class="commission-th">
                    {{
                      'dashboard-activity.component.credit_card_header'
                        | localise: 'Credit Card'
                    }}
                  </th>
                  <td mat-cell *matCellDef="let app" class="commission-td">
                    {{ app.creditCard?.cardNumberMask || '-' }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="description">
                  <th mat-header-cell *matHeaderCellDef class="commission-th">
                    {{
                      'dashboard-activity.component.description_header'
                        | localise: 'Description'
                    }}
                  </th>
                  <td mat-cell *matCellDef="let app" class="commission-td">
                    {{ app.description }}
                  </td>
                </ng-container>
                @if (withSubTable) {
                  <ng-container matColumnDef="actions">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      class="w-10 commission-th">
                      {{
                        'dashboard-activity.component.actions'
                          | localise: 'Actions'
                      }}
                    </th>
                    <td mat-cell *matCellDef="let app" class="commission-td">
                      @if (app.groupId && !app.payment) {
                        <mat-icon
                          class="cursor-pointer"
                          (click)="clickToggleSubTransactions(app)">
                          {{ app.expanded ? 'expand_less' : 'expand_more' }}
                        </mat-icon>
                      }
                      @if (app.payment && app.createdByUserId) {
                        @if (
                          app.promisedPaymentStatus ===
                          PromisedPaymentStatusEnum.Failed
                        ) {
                          <button
                            mat-button
                            class="p-button p-button--inline p-button--secondary p-actions warning-btn"
                            (click)="schedulePayment(app.id)">
                            {{
                              'deal-details.component.resolve'
                                | localise: 'Resolve'
                            }}
                          </button>
                        }
                        @if (
                          app.promisedPaymentStatus !==
                            PromisedPaymentStatusEnum.Processing &&
                          app.promisedPaymentStatus !==
                            PromisedPaymentStatusEnum.Failed
                        ) {
                          <button
                            mat-button
                            class="p-button p-button--inline p-button--secondary p-actions"
                            (click)="cancelPayment(app.id, confirmRemovedTmp)">
                            {{
                              'deal-details.component.cancel'
                                | localise: 'Cancel'
                            }}
                          </button>
                        }
                      }
                    </td>
                  </ng-container>
                }

                <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                @if (withSubTable) {
                  <ng-container matColumnDef="_expandedDetail">
                    <td
                      mat-cell
                      *matCellDef="let element"
                      [attr.colspan]="columns.length">
                      <div
                        class="expand-element-detail"
                        [@detailExpand]="
                          element.expanded ? 'expanded' : 'collapsed'
                        ">
                        @if (element.loading) {
                          <div class="spinner-wrapper">
                            <mat-spinner diameter="40"></mat-spinner>
                          </div>
                        }
                        @if (!element.loading && element.subTransactions) {
                          <ng-container
                            *ngTemplateOutlet="
                              activityFullTable;
                              context: {
                                withSubTable: false,
                                dataSource: element.subTransactions,
                                columns: subColumns,
                                subColumns: subColumns,
                              }
                            "></ng-container>
                        }
                      </div>
                    </td>
                  </ng-container>
                }
                <tr
                  mat-header-row
                  *matHeaderRowDef="withSubTable ? columns : subColumns"></tr>
                <tr
                  mat-row
                  *matRowDef="
                    let row;
                    columns: withSubTable ? columns : subColumns
                  "></tr>
                @if (withSubTable) {
                  <tr
                    mat-row
                    class="expand-detail-row"
                    *matRowDef="
                      let row;
                      columns: ['_expandedDetail'];
                      when: isExpansionDetailRow
                    "></tr>
                }
              </table>
            </ng-template>
            <div class="support">
              <img src="assets/img/icons/info-warning.svg" />
              <div>
                {{
                  'deal-details.component.please_contact_support'
                    | localise
                      : 'If you need additional support regarding this deal, please contact support by emailing'
                }}
                <a href="mailto:support@gettongo.com">{{
                  'deal-details.component.support_gettongo_com_link'
                    | localise: 'support@gettongo.com'
                }}</a>
                {{
                  'deal-details.component.support_calling'
                    | localise: 'or calling (929) 456-5396'
                }}.
              </div>
            </div>
          </div>
        }
      </div>
    }
  }
  <ng-template #updateClosingDateTmp>
    <div class="close-dialog-holder">
      <button
        mat-icon-button
        mat-dialog-close
        type="button"
        class="close-dialog-button">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
    <form
      [formGroup]="promisedPaymentForm"
      (ngSubmit)="updateDealClosingDate()">
      <mat-dialog-content>
        @if (promisedPayment) {
          <p class="closing-date-description">
            {{
              'deal-details.component.adjust_closing_date_or_set_new_payment_date'
                | localise
                  : 'Adjust your closing date or set a new payment date here. The amount you owe may change with the dates.'
            }}
          </p>
          <p>
            <strong>
              {{
                (promisedPaymentPreview | totalByPromisedList) ||
                  promisedPayment.total | currencyJs: { showSymbol: true }
              }}
              {{ 'deal-details.component.amount_due' | localise: 'due' }}
            </strong>
          </p>
        }
        @if (promisedPaymentPreview) {
          <mat-divider></mat-divider>
          <p>
            <strong>{{
              'deal-details.component.you_should_pay'
                | localise: 'You should pay:'
            }}</strong>
          </p>
          @for (payment of promisedPaymentPreview; track payment.id) {
            <p>
              {{
                payment.effectiveDate | dateApp: formatDateEnum.MMDDYYYY : true
              }}:
              {{ payment.total | currencyJs: { showSymbol: true } }}
            </p>
          }
        }
        @if (promisedPayment) {
          <mat-divider></mat-divider>
        }
        <div class="dates__closing">
          <h3>
            {{
              'deal-details.component.payment_closing_date'
                | localise: 'Closing Date'
            }}
          </h3>
          <mat-calendar
            [minDate]="closingDateMin"
            [selected]="promisedPaymentForm.get('closingDate')?.value"
            (selectedChange)="
              promisedPaymentForm.get('closingDate')?.setValue($event)
            ">
          </mat-calendar>
        </div>

        @if (
          promisedPaymentForm.controls.closingDate.value
            | isMoreDays: deal?.closingDate : maxDiffClosingDate
        ) {
          <div class="upload-document">
            @if (!promisedPaymentForm.controls.userDealDocumentId.value) {
              <p class="addendum-doc-explain">
                {{
                  'deal-details.component.upload_extension_or_addendum_for_listing'
                    | localise
                      : 'Please upload the extension/addendum for this listing'
                }}
              </p>

              <mat-form-field appearance="fill">
                <mat-label>{{
                  'deal-details.component.payment_description'
                    | localise: 'Description'
                }}</mat-label>
                <textarea
                  matInput
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="descriptionForClosingDate"></textarea>
              </mat-form-field>

              @if (loadingFile) {
                <mat-spinner [diameter]="22"></mat-spinner>
              }

              <label
                class="upload-button p-button p-button--rounded p-button--apply-now-header"
                [class.hidden]="loadingFile">
                {{
                  'deal-details.component.payment_upload_document'
                    | localise: 'Upload Document'
                }}
                <input
                  type="file"
                  accept=".pdf,.doc,.docx,.dot,.dotx,.docm,.dotm"
                  ngFileSelect
                  [options]="options"
                  (uploadOutput)="
                    onUploadOutput(
                      $event,
                      userDealDocumentDocumentTypeEnum.ExpansionAddendum,
                      descriptionForClosingDate
                    )
                  "
                  [uploadInput]="uploadInput" />
              </label>
            } @else {
              <span class="document-is-uploaded">
                {{
                  'deal-details.component.payment_document_uploaded'
                    | localise: 'Document is uploaded'
                }}
                <mat-icon class="material-icons-outlined" color="accent"
                  >check_circle</mat-icon
                >
              </span>
            }
          </div>
        }
        @if (error) {
          @switch (error) {
            @case ('Only one closing date change is allowed') {
              <p
                class="p-error-message p-error-message--margin only-one-closing-date-change">
                {{
                  'deal-details.component.one_closing_date_change_is_allowed'
                    | localise: 'Only one closing date change is allowed.'
                }}<br />
                {{
                  'deal-details.component.to_change_closing_date_contact'
                    | localise
                      : 'If you need to change the closing date, please contact'
                }}
                <a href="mailto:{{ sharedService.companyEmail }}">{{
                  sharedService.companyEmail
                }}</a>
                {{
                  'deal-details.component.to_change_closing_date_call'
                    | localise: 'or call'
                }}
                <a href="tel:{{ sharedService.companyPhone }}">{{
                  sharedService.companyPhoneFormatted
                }}</a>
              </p>
            }
            @default {
              <p
                class="p-error-message p-error-message--margin only-one-closing-date-change">
                {{ error }}
              </p>
            }
          }
        }
      </mat-dialog-content>

      <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close class="dialog-button" type="button">
          {{ 'deal-details.component.cancel_button' | localise: 'Cancel' }}
        </button>
        <button
          mat-button
          cdkFocusInitial
          class="dialog-button dialog-button--primary"
          type="submit">
          {{ 'deal-details.component.update_button' | localise: 'Update' }}
        </button>
      </mat-dialog-actions>
    </form>
  </ng-template>

  <ng-template #confirmRemovedTmp>
    <h1 mat-dialog-title>
      {{
        'dashboard-banks.component.cancel_scheduled_payment'
          | localise: 'Cancel scheduled payment?'
      }}
    </h1>
    <div mat-dialog-content>
      {{
        'dashboard-activity.component.confirm_cancel_payment'
          | localise
            : 'Please confirm that you would like to cancel this scheduled payment.'
      }}
    </div>

    <div mat-dialog-actions>
      <button mat-button type="button" mat-dialog-close class="m-r-a wide-btn">
        {{ 'dashboard-activity.component.close' | localise: 'Close' }}
      </button>
      <button
        mat-button
        type="submit"
        [mat-dialog-close]="true"
        class="dialog-button--primary">
        {{
          'dashboard-activity.component.yes_cancel_payment'
            | localise: 'Yes, Cancel Payment'
        }}
      </button>
    </div>
  </ng-template>
</div>
